import { render, staticRenderFns } from "./LessonplanLessonplans.vue?vue&type=template&id=66228921&"
import script from "./LessonplanLessonplans.vue?vue&type=script&lang=js&"
export * from "./LessonplanLessonplans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports